<template>

    <div class="container">

        <div id="messages"></div>

        <div class="checklist-header">
            <h1>
                <i @click="loadWorkcentres()" class="fas fa-project-diagram"></i>
                Workcentre Dashboard
                <span class="h4 checklist-subtitle">
                    <span :class="{ subtitleCurrentWeek: week.isCurrentWeek }">Week {{ week.num }}</span>,
                    <span v-if="week.isCurrentWeek">commenced</span>
                    <span v-else>commencing</span>
                    {{ week.start }}
                </span>
            </h1>
            <div class="checklist-week-nav">
                <button id="toggle-expand-all-btn"
                        class="btn btn-default"
                        @click="all_expanded = !all_expanded"
                        :title="(all_expanded ? 'Contract' : 'Expand') + ' All Boxes'">
                    <i v-if="all_expanded" class="fas fa-caret-up"></i>
                    <i v-else class="fas fa-caret-down"></i>
                </button>
                <button class="btn btn-default" @click="weekNavBack()" title="Previous Week"><i class="fas fa-arrow-alt-left"></i></button>
                <button class="btn btn-default"  @click="weekNavForward()" title="Next Week"><i class="fas fa-arrow-alt-right"></i></button>
            </div>
        </div>

        <div :class="['workcentres']">
            <workcentre v-for="(workcentre, index) in workcentres"
                  :workcentre="workcentre"
                  :totals="totalsWorkcentre"
                  :expanded="all_expanded"
                  :key="workcentre.id">
            </workcentre>
        </div>

    </div>

</template>

<script>

    import {default as _} from "lodash";
    import miniToastr from "mini-toastr";
    import Workcentre from "../workcentre_dashboard/Workcentre";
    import api from "../../api";

    let Vue = window.Vue;

    export default {

        props: {
            week_prop: {
                type: Object,
                required: true,
            },
        },

        data: () => ({
            app_url: window.location.protocol + "//" + window.location.host,
            week: {},
            loading: false,
            last_loaded: Date.now(),
            users: [],
            workcentres: [],
            workcentre_totals: [],
            all_expanded: false,
        }),

        components: {
            miniToastr,
            Workcentre,
        },

        async created() {
            window.Echo.channel('checklist')
                .listen('ChecklistCreated', e => {
                    console.log('Broadcast: ChecklistCreated: loadTable()');
                    this.loadWorkcentres();
                })
                .listen('ChecklistUpdated', e => {
                    console.log('Broadcast: ChecklistUpdated: loadTable()');
                    this.loadWorkcentres();
                })
                .listen('ChecklistDeleted', e => {
                    console.log('Broadcast: ChecklistDeleted: loadTable()');
                    this.loadWorkcentres();
                });
        },

        mounted() {
            this.week = JSON.parse(JSON.stringify(this.week_prop));
            this.updateUrl();
            this.loadWorkcentres();

            miniToastr.init({
                timeout: 3000,
                appendTarget: document.getElementById('messages'),
            });
        },

        destroyed() {
            window.Echo.leaveChannel('checklist');
        },

        methods: {
            syncWorkcentresFromStore() {
                this.workcentres = JSON.parse(JSON.stringify(this.$store.workcentres));
            },
            weekNav(direction) {
                var d = new Date(Date.UTC(this.week.year, 0, 4));
                d.setUTCDate(d.getUTCDate() + (this.week.num - 1) * 7 + (direction * 7));
                var dayOfYear = Math.round((d - new Date(Date.UTC(d.getUTCFullYear(), 0, 1))) / 86400000) + 1;
                var weekDay = (d.getUTCDay() + 6) % 7;
                this.week.num = Math.ceil((dayOfYear - weekDay + 9) / 7);
                if (this.week.num >= 52 && d.getUTCMonth() === 0) this.week.year = d.getUTCFullYear() - 1;
                else if (this.week.num === 1 && d.getUTCMonth() === 11) this.week.year = d.getUTCFullYear() + 1;
                else this.week.year = d.getUTCFullYear();
                this.loadWorkcentres();
            },
            weekNavBack() {
                this.weekNav(-1);
            },
            weekNavForward() {
                this.weekNav(1);
            },
            loadWorkcentres() {
                this.loading = true;
                return api.getWorkcentreDashboard(this.week.year, this.week.num).then(data => {
                    this.loading = false;
                    if (api.responseHasErrors(data)) return;
                    this.updateUrl();

                    this.$store.workcentres = data.workcentres;
                    this.workcentres = data.workcentres;

                    this.$store.workcentre_totals = data.workcentre_totals;
                    this.workcentre_totals = data.workcentre_totals;

                    this.$store.users = data.users;
                    this.users = data.users;

                    this.week = data.week;
                    this.last_loaded = Date.now();
                });
            },
            updateUrl() {
                history.replaceState(null, '', this.url);
            },
        },

        computed: {
            url() {
                return `${this.app_url}/workcentre-dashboard/${this.week.year}/${this.week.num}`;
            },
            totalsWorkcentre() {
                return _.last(this.workcentres);
            },
        },

    }

</script>

<style>

    .workcentres {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .checklist-header h1 .fas {
        margin-right: 15px;
    }
    .checklist-header h1 {
        font-size: 28px;
    }
    @media (min-width: 768px) {
        .checklist-header h1 {
            font-size: 36px;
        }
    }

    .loadingfade { opacity: 0.5; }
    .stat {
        display: inline-block;
        min-width: 28px;
        padding: 3px 5px;
        font-size: 12px;
        font-weight: 400;
        line-height: 1;
        color: #fff;
        text-align: center;
        white-space: nowrap;
        border-radius: 3px;
        margin-right: 10px;
        background-color: #6b6f6b;
        opacity: 0.75;
        flex-shrink: 0;
    }
    @media (min-width: 992px) {
        .stat {
            padding: 5px 7px;
            font-size: 14px;
            font-weight: 600;
            margin-right: 20px;
        }
    }
    .small-stat {
        background-color: #979797;
        padding: 3px 5px;
        font-size: 12px;
        font-weight: 600;
    }
    .checklist-header {
        display: flex;
        margin: 10px 0 50px 0;
        justify-content: space-between;
        align-items: center;
    }
    .checklist-subtitle {
        display: block;
        padding: 15px 0 0 25px;
        color: #666;
        margin: 0 24px;
        font-size: 15px;
    }
    @media (min-width: 768px) {
        .checklist-subtitle {
            font-size: 18px;
            padding: 15px 0 0 34px;
        }
    }
    .subtitleCurrentWeek {
        border-bottom: 2px solid #428c38;
        color: #14590b;
    }
    .checklist-week-nav {
        display: flex;
        height: 40px;
    }
    .checklist-week-nav button {
        font-size: 18px;
        color: #6c6c6c;
        margin: 0 5px;
    }

    #toggle-expand-all-btn {
        margin-right: 50px;
    }

    .mini-toastr {
        position: absolute !important;
        right: 0 !important;
        top: 0 !important;
    }
    .mini-toastr-notification__message {
        padding: 0 !important;
    }
    #messages {
        position: relative;
    }
    .mini-toastr__notification.-success {
        background-color: #15831a !important;
    }
</style>